import { forwardRef, type Ref, type SVGProps } from "react";
const IconRenameFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M19 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h15v2H4v8h15z"
    />
    <path
      fill="currentColor"
      d="M28 10h-5V7h3V5h-8v2h3v18h-3v2h8v-2h-3v-3h5a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2m0 10h-5v-8h5z"
    />
    <path fill="currentColor" d="M6 14h13v4H6z" />
  </svg>
);
const ForwardRef = forwardRef(IconRenameFilledSVG);
ForwardRef.displayName = "IconRenameFilled";
export { ForwardRef as IconRenameFilled };
